import { inject } from "@angular/core";
import { CanActivateFn, Router } from "@angular/router";
import { toObservable } from "@angular/core/rxjs-interop";
import { filter, map, take } from "rxjs";
import { AuthStore } from "../+state/auth";
import { EMPTY_STATE_MESSAGES } from "../constants";

export const organizationGuard: CanActivateFn = () => {
  const authStore = inject(AuthStore);
  const router = inject(Router);

  return toObservable(authStore.memberUser).pipe(
    filter((res) => !!res),
    take(1),
    map((res) => {
      if (res.primaryOrganization?.orgId !== null && res.primaryOrganization?.orgId !== undefined) {
        return true;
      }

      router.navigate(["error"], {
        queryParams: { error_description: EMPTY_STATE_MESSAGES.NO_ORGANIZATION, main_action: false },
      });

      return false;
    }),
  );
};
